import { GeneralStatsMetric } from 'interfaces/general-stats.interface';

export const GENERAL_STATS_METRICS: GeneralStatsMetric[] = [
  { id: 'transactionPercent', label: 'Operations', color: '#a8385d', dataCy: 'general-transaction-percent' },
  { id: 'bouncePercent', label: 'New Visits', color: '#7aa3e5', dataCy: 'general-new-visits' },
  { id: 'newVisitPercent', label: 'Bounce', color: '#a27ea8' },
];
